import React from "react";
import * as Sentry from "@sentry/react";
import i18n from "@/i18n/config";

interface Props {
  children: React.ReactNode;
}

interface State {
  hasError: boolean;
  error: Error | null;
}

export class ErrorBoundary extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    Sentry.captureException(error, {
      contexts: {
        react: {
          componentStack: errorInfo.componentStack,
        },
      },
    });
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-background">
          <div className="text-center px-4">
            <h1 className="text-2xl font-display mb-4">{i18n.t("errorBoundary.title")}</h1>
            <p className="text-muted-foreground mb-6">{i18n.t("errorBoundary.description")}</p>
            <button
              type="button"
              onClick={() => {
                this.setState({ hasError: false, error: null });
                window.location.href = "/";
              }}
              className="px-4 py-2 border border-border rounded hover:bg-muted transition-colors"
            >
              {i18n.t("errorBoundary.home")}
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}
